import { render } from "./CreateAgent.vue?vue&type=template&id=13b639c2"
import script from "./CreateAgent.vue?vue&type=script&lang=js"
export * from "./CreateAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__